import { LocalMedia } from './Media'

export const getLocalImage = (
  req: { default: any },
  mime: string
): LocalMedia => {
  const { width, height } = req.default
  return {
    id: req.default.src ?? '',
    type: 'local',
    url: req.default.src ?? '',
    ratio: width && height ? width / height : undefined,
    width,
    height,
    mime,
  }
}
